import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../views/HomePage.vue'
import LoginPage from '../views/LoginPage.vue'
import ProfilePage from '../views/ProfilePage.vue'
import HistoryPage from '../views/HistoryPage.vue'
import SupperPage from '../views/SupperPage.vue'
import UserPage from '../views/UserPage.vue'

// 新增矩阵管理模块的简单测试页面
import MatrixPage from '../views/Matrix.vue'
import MatrixAccountGroup from '../views/MatrixAccountGroup.vue'
import MatrixAuthorizedAccount from '../views/MatrixAuthorizedAccount.vue'
import MatrixScheduledPublish from '../views/MatrixScheduledPublish.vue'
import MatrixPublishingTask from '../views/MatrixPublishingTask.vue'
import MatrixMaterialGroup from '../views/MatrixMaterialGroup.vue'
import MatrixMaterialCenter from '../views/MatrixMaterialCenter.vue'

const routes = [
  { path: '/', redirect: '/home' },
  { path: '/home', name: 'HomePage', component: HomePage },
  { path: '/profile', name: 'ProfilePage', component: ProfilePage },
  { path: '/history', name: 'HistoryPage', component: HistoryPage },
  { path: '/super', name: 'SupperPage', component: SupperPage },
  { path: '/user', name: 'UserPage', component: UserPage, props: (route) => ({ taskId: route.query.task_id, Id: route.query.id }) },
  { path: '/login', name: 'LoginPage', component: LoginPage },

  // 矩阵管理模块及其子页面
  {
    path: '/matrix',
    name: 'MatrixPage',
    component: MatrixPage,
    children: [
      {
        path: 'account-group',
        name: 'AccountGroup',
        component: MatrixAccountGroup
      },
      {
        path: 'authorized-account',
        name: 'AuthorizedAccount',
        component: MatrixAuthorizedAccount
      },
      {
        path: 'scheduled-publish',
        name: 'ScheduledPublish',
        component: MatrixScheduledPublish
      },
      {
        path: 'publishing-task',
        name: 'PublishingTask',
        component: MatrixPublishingTask
      },
      {
        path: 'material-group',
        name: 'MaterialGroup',
        component: MatrixMaterialGroup
      },
      {
        path: 'material-center',
        name: 'MaterialCenter',
        component: MatrixMaterialCenter
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
